@if (tenant) {
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h2>Tenant {{ tenant.id }}</h2>
    <button mat-icon-button [routerLink]="['../']" matTooltip="Back to Tenants">
      <mat-icon>arrow_back</mat-icon>
    </button>
  </div>
  <mat-list>
    <mat-list-item>Name: {{ tenant.name }}</mat-list-item>
    <mat-list-item>Description: {{ tenant.description }}</mat-list-item>
    <mat-list-item>Status: {{ tenant.status }}</mat-list-item>
  </mat-list>
  <app-client-list [loadedClients]="tenant.clients"></app-client-list>
}
